const angular = require('angular');
const app = angular.module('learn-directives');

/**
 * Defines the add video component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Files} defines the Files resource
 */
app.directive('addFile', ['Application', 'Authorization', 'Files', 'S3Uploads', 'Upload', 'ErrorReporting', '$sce', '$http', '$translate', function(Application, Authorization, Files, S3Uploads, Upload, ErrorReporting, $sce, $http, $translate) {
    return {
      restrict: 'E',
      scope: {
        file: '=',
        type: '='
      },
      template: require('../../../templates/directives/cms/add-file.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          self.currentUser = Authorization.getAuthToken().user;
          self.generativeAIEnabled = Application.features.flags().enable_generative_ai;
          self.fileName;
          self.uploaderId = 'file-upload';
          self.translations = {};
          var colorList = Application.colors.get();
          self.brandColor = colorList ? colorList[0] : '#00BCF1';
          self.stopProp = function(evt) {
            evt.stopPropagation();
          }
          self.chooseUseGenerativeAI = function(bool) {
            $scope.file.use_generative_ai = bool;
          }

          var destroyCheck = {};
          self.allowDrive = function() {
            return Authorization.getAuthToken() && Authorization.getAuthToken().company && Authorization.getAuthToken().company['google_drive'];
          };

          self.type = $scope.type ? $scope.type : '';

          self.browseFile = function() {
            document.getElementById(self.uploaderId).click();
          };

          $scope.$watch('addFile.uploadedFile', function(newVal, oldVal) {
            if(newVal && !newVal.$error) {
              self.onFileSelect(self.uploadedFile);
            }
          });

          self.linkMatch = function(link) {
            if (link.match('prezi.com')) {
              if (!link.match('/embed')) {
                link = link + 'embed';
              }
              return {
                link: link,
                type: 'prezi',
                ratio: ".5625"
              }
            }

            if (link.match('app.box.com')) {
              return {
                type: 'box',
                ratio: "1.2941"
              }
            }

            if (link.match('wistia.com')) {
              return {
                type: 'wistia',
                ratio: ".5625"
              }
            }

            if (link.match('soundcloud.com')) {
              return {
                type: 'soundcloud',
                ratio: ".18"
              }
            }

            if (link.match('slideshare.net')) {
              return {
                type: 'slideshare',
                ratio: ".75"
              }
            }

            if (link.match('spotify.com')) {
              return {
                type: 'spotify',
                ratio: ".333"
              }
            }

            if (link.match('docs.google.com')) {
              if (link.match('presentation')) {
                return {
                  type: 'google-presentation',
                ratio: ".5625"
                }
              }

              return {
                type: 'google-doc',
                ratio: "1.2941"
              }
            }

            return {
              type: 'other',
              ratio: ".5625"
            }
          };

          self.selectEmbed = function() {
            $scope.file.embed = true;
            self.selectingEmbed = true;
          };

          self.addEmbed = function() {
            if (!self.embedText) {
              return;
            }


            if($scope.file.link) {
              self.oldFile = $scope.file.link.slice(0);
            }
            if($scope.file.source_v2) {
              self.oldSource = $scope.file.source_v2.slice(0);
            }
            if($scope.file.source_id_v2) {
              self.oldSourceId = $scope.file.source_id_v2.slice(0);
            }
            if($scope.file.embed_settings) {
              self.oldEmbedSettings = $scope.file.embed_settings;
            }
            if($scope.file.embed) {
              self.oldEmbed = true;
            }

            self.changing = false;
            self.selectingEmbed = false;
            var embedSettings;
            var height;
            var width;
            var link;

            if (self.embedText.indexOf('<iframe') !== -1) {

              var srcSplit = self.embedText.split('src="');
              if (srcSplit && srcSplit.length === 2) {
                link = srcSplit[1].split('"')[0];
              }

              var heightSplit = self.embedText.split('height="');
              if (heightSplit && heightSplit.length > 1) {
                height = heightSplit[1].split('"')[0];
              }

              var widthSplit = self.embedText.split('width="');
              if (widthSplit && widthSplit.length > 1) {
                width = widthSplit[1].split('"')[0];
              }

            }

            var type = self.linkMatch(link || self.embedText);
            link = type.link || link || self.embedText;
            delete type.link;
            embedSettings = type;

            if (height && width) {
              function roundToXDigits(value, digits) {
                if(!digits){
                  digits = 2;
                }
                value = value * Math.pow(10, digits);
                value = Math.round(value);
                value = value / Math.pow(10, digits);
                return value;
              };
              var widthToSet = (width !== '100%' ? width : document.querySelector('.contentview__hero--file').clientWidth);
               var heightToSet = height;
              embedSettings.ratio = roundToXDigits((parseInt(heightToSet) / parseInt(widthToSet)),2);
              embedSettings.width = parseInt(widthToSet);
              embedSettings.height = parseInt(heightToSet);
            }

            $scope.file.embed_settings = embedSettings;

            if (link.slice(0, 5) !== 'https') {
              if (link.slice(0, 4) === 'http') {
                link = link.replace('http', 'https');
              } else if (link.slice(0, 2) === '//') {
                link = 'https:' + link;
              } else {
                link = 'https://' + link;
              }
            }

            $scope.file.link = link;
            self.trustedLink = $sce.trustAsResourceUrl($scope.file.link);

          };

          self.googleSelect = function(url, token) {
            self.driveUploading = true;
            self.selectingEmbed = false;
            $http.post('files/google-file', {url: url, token: token})
            .then(function(data) {
              data = data.data;
              if (!data.link) {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.google_error'], duration: 5});
                self.driveUploading = false;
                return;
              }

              if($scope.file.link) {
                self.oldFile = $scope.file.link.slice(0);
              }
              if($scope.file.source_v2) {
                self.oldSource = $scope.file.source_v2.slice(0);
              }
              if($scope.file.source_id_v2) {
                self.oldSourceId = $scope.file.source_id_v2.slice(0);
              }
              if($scope.file.embed_settings) {
                self.oldEmbedSettings = $scope.file.embed_settings;
              }
              if($scope.file.embed) {
                self.oldEmbed = true;
              }

              self.isPdf = true;
              self.imageLoading = false;
              self.loadingBar = false;
              self.changing = false;
              self.driveUploading = false;
              self.loaded = true;

              $scope.file.embed = false;
              $scope.file.fileName = self.fileName;
              $scope.file.link = data.link;
              self.trustedLink = data.link;

              if(initWatch) {
                initWatch();
              }
            }).catch(function(err) {
              self.driveUploading = false;
              ErrorReporting.send({
                message: 'Error in drive file upload request. User (' + self.currentUser._id + ') in company (' + self.currentUser.company + ').',
                context: err
              });
              if (err && err.data && err.data.error && err.data.error === 'Size Limit Reached') {
                Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.files.exceed_limit']});
                return;
              }
              if (error && error.data && error.data.error && error.data.error.error && error.data.error.error.errors && error.data.error.error.errors[0] && error.data.error.error.errors[0].reason && error.data.error.error.errors[0].reason == 'domainPolicy') {
                Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.admin_disabled_google'], duration: 6});
                return;
              }
              Application.messaging.addMessage({type: 'error', duration: 6, text: self.translations['edit.files.upload_error']});
            });
          }

          self.onFileSelect = function(uploaded) {
            self.fileName = uploaded.name;
            self.selectingEmbed = false;
            if(uploaded.size > 500000000) {
              Application.messaging.addMessage({type: 'error', text: self.translations['edit.files.exceed_limit_500'], duration: 5});
              return;
            }
            if(uploaded.type === '') {
              uploaded.type = 'application/octet-stream';
            }

            S3Uploads.filePolicy({fileName: uploaded.name, contentType: uploaded.type}, function(data) {
              var cloudFrontLink = data.CloudFrontLink;
              Upload.upload({
                url: 'https://' + data.Bucket + '.s3.amazonaws.com/',
                headers: {'Remove-auth': 'yes'},
                method: 'POST',
                data: {
                  key: data.Key,
                  'Content-Type': data.ContentType,
                  AWSAccessKeyId: data.AWSAccessKeyId,
                  'success_action_status': '201',
                  policy: data.S3Policy,
                  signature: data.S3Signature
                },
                file: uploaded
              }).progress(function(evt) {
                var percent = parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10);
                self.loadingBar = true;
                self.loadingPercent = percent;
                self.progress = {'width': parseInt(100.0 * evt.loaded / (evt.total * 0.05 + evt.total), 10) + '%'};
              }).success(function(data) {
                self.isPdf = false;
                if($scope.file.link) {
                  self.oldFile = $scope.file.link.slice(0);
                }
                if($scope.file.source_v2) {
                  self.oldSource = $scope.file.source_v2.slice(0);
                }
                if($scope.file.source_id_v2) {
                  self.oldSourceId = $scope.file.source_id_v2.slice(0);
                }
                if($scope.file.embed_settings) {
                  self.oldEmbedSettings = $scope.file.embed_settings;
                }
                if($scope.file.embed) {
                  self.oldEmbed = true;
                }

                if (cloudFrontLink && typeof cloudFrontLink.slice(-3) === 'string' && cloudFrontLink.slice(-3).toLowerCase() === 'pdf') {
                  self.isPdf = true;
                  self.imageLoading = false;
                  self.loadingBar = false;
                  self.changing = false;

                  $scope.file.embed = false;
                  $scope.file.fileName = self.fileName;
                  $scope.file.link = cloudFrontLink;
                  self.trustedLink = cloudFrontLink;

                  if(initWatch) {
                    initWatch();
                  }

                  return;
                }

                Files.boxSource({}, {link: cloudFrontLink}, function(data) {
                  if (!data || !data.source_v2) {
                    return;
                  }
                  destroyCheck[data.source_id_v2] = true;

                  self.imageLoading = false;

                  if(initWatch) {
                    initWatch();
                  }

                  self.trustedLink = data.source_v2 ? $sce.trustAsResourceUrl(data.source_v2) : cloudFrontLink;
                  $scope.file.source_id_v2 = data.source_id_v2;
                  $scope.file.source_id = data.source_id;
                  $scope.file.source_v2 = data.source_v2;
                  $scope.file.source = data.source;
                  $scope.file.link = cloudFrontLink;
                  $scope.file.fileName = self.fileName;
                  $scope.file.embed = false;

                  self.loadingBar = false;
                  self.changing = false;
                });
              }).catch(function(error) {
                console.log('upload error', error);
              });
            }, function(error) {
              Application.messaging.addMessage({type: 'error', text: error.message, duration: 5});
            });

          };

          self.undoLink = function() {
            self.isPdf = false;
            $scope.file.source_v2 = self.oldSource;
            $scope.file.source_id_v2 = self.oldSourceId;
            $scope.file.link = self.oldFile;
            $scope.file.embed = self.oldEmbed;
            if (self.oldEmbedSettings) {
              $scope.file.embed_settings = self.oldEmbedSettings;
            }
            if (self.oldFile && typeof self.oldFile.slice(-3) === 'string' && self.oldFile.slice(-3).toLowerCase() === 'pdf') {
              self.isPdf = true;
            }
            self.trustedLink = self.isPdf ? self.oldFile : $sce.trustAsResourceUrl(self.oldSource);
            self.oldFile = '';
            self.oldSource = '';
            self.oldSourceId = '';
            self.oldEmbed = false;
          };

          $translate([
            'edit.files.google_error',
            'edit.files.exceed_limit',
            'edit.files.admin_disabled_google',
            'edit.files.upload_error',
            'edit.files.exceed_limit_500',
          ]).then(function(translations) {
            self.translations = translations;
          });

          $scope.$on('$destroy', function () {
            // This checks to remove any unused box sources - if the source is located in a file, nothing will be done
            Object.keys(destroyCheck).forEach(function(source) {
              Files.checkBox({fileId: source}, {});
            });
          });

          var initWatch = $scope.$watch('file.source_v2', function(newVal, oldVal) {
            if(!newVal || oldVal === newVal) {
              return;
            }
            if ($scope.file && $scope.file.link && typeof $scope.file.link.slice(-3) === 'string' && $scope.file.link.slice(-3).toLowerCase() === 'pdf'){
              initWatch();
              return;
            }
            self.isPdf = false;
            self.trustedLink = $scope.file.source_v2 ? $sce.trustAsResourceUrl($scope.file.source_v2) : $scope.file.link;
            initWatch();
            if (linkWatch) {
              linkWatch();
            }
          });

          var linkWatch = $scope.$watch('file.link', function(newVal, oldVal) {
            if(!newVal || oldVal === newVal) {
              return;
            }

            if ($scope.file.embed) {
              self.isPdf = false;
              self.trustedLink = $sce.trustAsResourceUrl($scope.file.link);
              return;
            }

            if ($scope.file && $scope.file.link && typeof $scope.file.link.slice(-3) === 'string' && $scope.file.link.slice(-3).toLowerCase() !== 'pdf'){
              linkWatch();
              return;
            }

            self.isPdf = true;
            self.trustedLink = $scope.file.link;
            linkWatch();

            if (initWatch) {
              initWatch();
            }
          });

        }],
      controllerAs: 'addFile'
    };
  }]);
